import React from 'react';
import IEStatefulBase from './IEStatefulBase';
import { observable, action } from "mobx";
import { observer, inject } from 'mobx-react';
import Select from 'react-select';


@inject("clusterStore")
@observer
export default class IEReactMultiSelectCluster extends IEStatefulBase {

    @observable clustervalue = [];

    constructor(props) {
        super(props);
        this.clustervalue = props.value.peek();
    }

    @action
    handleSelectChange(newValue) {
        let allOption = newValue.filter(field => field.value === 'ALL');
        if (allOption.length > 0) {
            newValue = this.props.clusterStore.ClusterOptions.filter(field => field.disabled !== true && field.value !== 'ALL')
        }
        this.clustervalue = newValue.map(item => item.value);
    }

    finishEditing = () => {
        this.props.beforeFinish && this.props.beforeFinish();
        let newValue = this.clustervalue; //domElem.value;
        const result = this.doValidations(newValue);
        if (result && this.props.value !== newValue) {
            this.commit(newValue);
        }
        if (!result && this.props.handleValidationFail) {
            this.props.handleValidationFail(result, newValue, () => this.cancelEditing());
        } else {
            this.cancelEditing();
        }
        this.props.afterFinish && this.props.afterFinish();
    };

    renderEditingComponent = () => {
        //const values = this.props.clusterStore.ClusterOptions.filter(item => this.props.value.includes(item.value));
        return (<div id="form-select-clusters--5"
            onBlur={() => this.finishEditing()} ref="input">
            <Select
                className={this.makeClassString()}
                options={this.props.clusterStore.ClusterOptions}
                resetValue={[]}
                multi={true}
                onChange={(newvalue) => this.handleSelectChange(newvalue)}
                value={this.clustervalue && this.clustervalue.peek()}
            /></div>);
    };

    renderNormalComponent = () => {
        const { value } = this.props;
        return <div className="post-detail-clusters" onFocus={this.startEditing} onClick={this.startEditing} {...this.props.defaultProps}>
        {value.map((cluster, i) => {
            return (<div className="post-detail-cluster" key={i + "-" + cluster}>
                {cluster}
            {!this.props.isDisabled &&  <img alt="End" className="post-detail-cluster-button-remove" src={require("../../assets/images/button-close.svg")} />}
            </div>
            //style={{this.props.isDisabled && "display:none"}}
        )})}
        {!this.props.isDisabled && <img src={require("../../assets/images/button-add.svg")} className="post-detail-cluster-button-add" alt="Add Cluster" title="Add Cluster" />}
        </div>
    };
}



// WEBPACK FOOTER //
// ./src/components/InlineEdit/IEReactMultiSelectCluster.js